import { gql } from 'apollo-boost';

export const GET_BOOK_TYPE_QUERY = gql`
query pack($bookTemplateCategoryId: ID!) {
    bookTemplateCategory(bookTemplateCategoryId: $bookTemplateCategoryId) {
        id
        description
        name
        iconUrl
        backgroundColor
        textColor
        # isSingleChapter
        bookTemplates {
            id
            name
            targetAge
            isVisible
        }
    }
}
`;

export const ADD_BOOK_TYPE_MUTATION = gql`
mutation addBookTemplateCategory($name: String!, $description: String!, $iconUrl: String, $backgroundColor: String, $textColor: String, $parentId:ID) {
    addBookTemplateCategory(name: $name, description: $description, iconUrl:$iconUrl, backgroundColor:$backgroundColor, textColor:$textColor, parentId:$parentId ) {
        bookTemplateCategory {
            id
            name
            description
            iconUrl
            backgroundColor
            textColor
            bookTemplates {
                id
                name
                chapters {
                    id
                    title
                }
            }
        }
        errors
    }
}
`;

export const DELETE_BOOK_MUTATION = gql`
mutation deleteBookTemplate($bookTemplateId: ID!) {
    deleteBookTemplate(bookTemplateId: $bookTemplateId) {
        deleted
        errors
    }
}
`;

export const GET_BOOK_TEMPLATE_USAGE_COUNT = gql`
query bookTemplateUsageCount($bookTemplateId: ID!) {
    bookTemplateUsageCount(bookTemplateId: $bookTemplateId)
}
`;

export const HIDE_BOOK_TEMPLATE = gql`
mutation hideBookTemplate($bookTemplateId: ID! $isVisible: Boolean!) {
    hideBookTemplate(bookTemplateId: $bookTemplateId, isVisible: $isVisible) {
        bookTemplate{
            id
            name
            description
            isVisible
        }
        errors
    }
}
`;